import React, { cloneElement, isValidElement, useCallback, useContext, useEffect, useRef, useState, } from 'react';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
import Trigger from 'choerodon-ui/lib/trigger/Trigger';
import { Action } from 'choerodon-ui/lib/trigger/enum';
import DropdownButton from './DropdownButton';
import { Placements } from './enum';
import builtinPlacements from './placements';
const popupStyle = { whiteSpace: 'nowrap' };
const Dropdown = function Dropdown(props) {
    const { getProPrefixCls } = useContext(ConfigContext);
    const { onOverlayClick, hidden: propsHidden, visible: propsVisible, trigger, overlay, children, placement, popupClassName, disabled, getPopupContainer, onHiddenBeforeChange, suffixCls, prefixCls: customizePrefixCls, onHiddenChange, onVisibleChange, } = props;
    const prefixCls = getProPrefixCls(suffixCls, customizePrefixCls);
    const [hidden, setHidden] = useState(() => {
        if ('hidden' in props) {
            return props.hidden;
        }
        if ('visible' in props) {
            return !props.visible;
        }
        if ('defaultHidden' in props) {
            return props.defaultHidden;
        }
        return !props.defaultVisible;
    });
    const renderedContentPropsRef = useRef();
    const getContent = useCallback((...popupProps) => {
        if (typeof overlay === 'function') {
            return overlay(...popupProps);
        }
        return overlay;
    }, [overlay]);
    const handleClick = useCallback((e) => {
        if (onOverlayClick) {
            onOverlayClick(e);
        }
        const { onClick } = renderedContentPropsRef.current || {};
        if (onClick) {
            onClick(e);
        }
        if (propsHidden === undefined && propsVisible === undefined) {
            setHidden(true);
        }
    }, [onOverlayClick, propsHidden, propsVisible]);
    const handlePopupHiddenChange = useCallback((hidden) => {
        if (propsHidden === undefined && propsVisible === undefined) {
            setHidden(hidden);
        }
        if (onHiddenChange) {
            onHiddenChange(hidden);
        }
        if (onVisibleChange) {
            onVisibleChange(!hidden);
        }
    }, [propsHidden, propsVisible, onHiddenChange, onVisibleChange]);
    const renderPopupContent = useCallback((...popupProps) => {
        const content = getContent(...popupProps);
        if (isValidElement(content)) {
            renderedContentPropsRef.current = content.props;
            return cloneElement(content, {
                onClick: handleClick,
            });
        }
    }, [getContent]);
    useEffect(() => {
        if (propsHidden !== undefined) {
            setHidden(propsHidden);
        }
        else if (propsVisible !== undefined) {
            setHidden(!propsVisible);
        }
    }, [propsHidden, propsVisible]);
    const triggerActions = disabled ? [] : trigger;
    return (React.createElement(Trigger, { prefixCls: prefixCls, action: triggerActions, builtinPlacements: builtinPlacements, popupPlacement: placement, popupContent: renderPopupContent, popupStyle: popupStyle, popupClassName: popupClassName, onPopupHiddenChange: handlePopupHiddenChange, onPopupHiddenBeforeChange: onHiddenBeforeChange, popupHidden: hidden, getPopupContainer: getPopupContainer }, children));
};
Dropdown.displayName = 'Dropdown';
Dropdown.Button = DropdownButton;
Dropdown.defaultProps = {
    suffixCls: 'dropdown',
    placement: Placements.bottomLeft,
    trigger: [Action.hover, Action.focus],
    defaultHidden: true,
};
export default Dropdown;
